import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SmallModal from "./modals/SmallModal";

const CallerSelector = ({ icon, text, modalTitle, children }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Box
        onClick={() => setShowModal(true)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "11px",
          padding: "14px 15px",
          cursor: "pointer",
          height: "100%",
          "&:hover": { borderColor: "#00a152", backgroundColor: "success.light" },
        }}
      >
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: "10px",
            backgroundColor: "success.light",
            color: "success.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <FontAwesomeIcon icon={icon} style={{ fontSize: 18 }} />
        </Box>
        <Typography sx={{ fontSize: 13, fontWeight: 600, lineHeight: 1.2 }}>{text}</Typography>
      </Box>

      <SmallModal titulo={modalTitle} isVisible={showModal} setVisible={setShowModal}>
        {children}
      </SmallModal>
    </>
  );
};

export default CallerSelector;
